// extracted by mini-css-extract-plugin
export default {"Root":"styles_Root__e+CMS"};